import { createSelector, MemoizedSelector } from '@ngrx/store';
import { Cart, StateUtils } from '@spartacus/core';
import { CustomCartState, StateWithCustomCart } from '../cart-state';
import { getCustomCartState } from './feature.selector';

export const getCloneCartState: MemoizedSelector<StateWithCustomCart, StateUtils.LoaderState<Cart>> = createSelector(
  getCustomCartState,
  (state: CustomCartState) => state.cloneCart,
);

export const getCloneCartValue: MemoizedSelector<StateWithCustomCart, Cart> = createSelector(
  getCloneCartState,
  (state: StateUtils.LoaderState<Cart>) => StateUtils.loaderValueSelector(state),
);
